﻿import { analyticsEvent } from '../../controllers/analytics-controller';
var AdvanceSearchController = function ($scope, $rootScope, $location, searchService, searchBootstrapper) {
  "use strict";
  var vm = this;
  vm.searchService = searchService;
  vm.searchBootstrapper = searchBootstrapper;
  vm.location = $location;
  vm.routerBuilder = vm.searchService.getRouteBuilder();
  vm.searchInput = document.getElementById("js-search-field");
  vm.headlinesOnly = null;
  vm.headlinesOnlySet = false;
  vm.entitledContentOnly = null;
  vm.entitledContentOnlySet = false;
  vm.includeFreeContent = null;
  vm.includeFreeContentSet = false;
  vm.exactMatchOnly = null;
  vm.exactMatchOnlySet = false;
  vm.isSearchEmpty = true;
  var doUpdate = false;

  var isQuoted = function(str) {
    if (!str || str.length < 1) return;
    var firstAndLastRegEx = /^.|.$/g;
    var firstAndLastArr = str.match(firstAndLastRegEx);
    var firstAndLastChar = firstAndLastArr ? firstAndLastArr.join('') : "";
    return firstAndLastChar === '""' || firstAndLastChar === '\'\'';
  };

  var addQuotes = function(str, isAdded) {
    var newStr;
    if (isAdded) {
      if (isQuoted(str)) return str;
      newStr = '"' + str + '"';
    } else {
      if (!isQuoted(str)) return str;
      newStr = str.replace(/['"]+/g, '');
    }
    return newStr;
  };

  $scope.$watch(function () {
    return vm.location.search();
  }, function (newValue) {
    doUpdate = false;
    vm.headlinesOnlySet = newValue.headlinesOnly && newValue.headlinesOnly === "1";
    vm.entitledContentOnlySet = newValue.entitledcontentonly && newValue.entitledcontentonly === "1";
    vm.includeFreeContentSet = newValue.includefreecontent && newValue.includefreecontent === "1";
    vm.exactMatchOnlySet = newValue.exactmatchonly && newValue.exactmatchonly === "1";
    vm.isSearchEmpty = newValue.q ? newValue.q.trim().length === 0 : true;
    if (isQuoted(newValue.q) !== Boolean(vm.exactMatchOnlySet))
      vm.exactMatchOnly = isQuoted(newValue.q)
  }, true);

  $scope.$watch(function () {
    return vm.headlinesOnly;
  }, function (newValue) {
    if (newValue === null || vm.headlinesOnlySet === newValue) return;
    doUpdate = true;
    vm.headlinesOnlySet = vm.headlinesOnly;
  });

  $scope.$watch(function () {
    return vm.headlinesOnlySet;
  }, function (newValue) {
    if (newValue !== vm.headlinesOnly)
      vm.headlinesOnly = newValue;
    if (vm.location.search().headlinesOnly === newValue) return;
    vm.searchBootstrapper.createFilter('headlinesOnly', newValue ? '1' : '');
    vm.update();
  });

  $scope.$watch(function () {
    return vm.entitledContentOnly;
  }, function (newValue) {
    if (newValue === null || vm.entitledContentOnlySet === newValue) return;
    doUpdate = true;
    vm.entitledContentOnlySet = vm.entitledContentOnly;
  });

  $scope.$watch(function () {
    return vm.entitledContentOnlySet;
  }, function (newValue) {
    if (newValue !== vm.entitledContentOnly)
      vm.entitledContentOnly = newValue;
    if (vm.location.search().entitledcontentonly === newValue) return;
    vm.searchBootstrapper.createFilter('entitledcontentonly', newValue ? '1' : '');
    vm.update();
  });

  $scope.$watch(function () {
    return vm.includeFreeContent;
  }, function (newValue) {
    if (newValue === null || vm.includeFreeContentSet === newValue) return;
    doUpdate = true;
    vm.includeFreeContentSet = vm.includeFreeContent;
  });

  $scope.$watch(function () {
    return vm.includeFreeContentSet;
  }, function (newValue) {
    if (newValue !== vm.includeFreeContent)
      vm.includeFreeContent = newValue;
    if (vm.location.search().includefreecontent === newValue) return;
    vm.searchBootstrapper.createFilter('includefreecontent', newValue ? '1' : '');
    vm.update();
  });

  $scope.$watch(function () {
    return vm.exactMatchOnly;
  }, function (newValue) {
    if (newValue === null || vm.exactMatchOnlySet === newValue) return;
    doUpdate = true;
    vm.exactMatchOnlySet = vm.exactMatchOnly;
  });

  $scope.$watch(function () {
    return vm.exactMatchOnlySet;
  }, function (newValue) {
    if (newValue !== vm.exactMatchOnly)
      vm.exactMatchOnly = newValue;
    if (vm.location.search().exactmatchonly === newValue) return;
    var qf = vm.searchService.getFilter('q');
    var qv = qf ? qf.getValue() : '';
    vm.searchBootstrapper.createFilter('exactmatchonly', vm.exactMatchOnly ? '1' : '');
    if (isQuoted(qv) !== vm.exactMatchOnly) {
      vm.searchBootstrapper.createFilter('q', addQuotes(qv, vm.exactMatchOnly));
      vm.searchInput.value = addQuotes(qv, vm.exactMatchOnly);
    }
    vm.update();
  });

  vm.update = function () {
    if (!doUpdate) return;
    var routerBuilder = vm.searchService.getRouteBuilder();
    vm.location.search(routerBuilder.getRoute());
    vm.searchService._advanceSearchUpdated = true;
    vm.searchService.query();
  };
};
var informaSearchApp = angular.module('informaSearchApp');
informaSearchApp.controller("AdvanceSearchController", ['$scope', '$rootScope', '$location', 'searchService', 'searchBootstrapper', AdvanceSearchController]);
